import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';
import Big from 'big.js';
import InquiryService from 'services/inquiry';
import ModalService from 'services/modal';
import Http from 'services/http2';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import IfbPriceCompare from 'components/ifbPriceCompare';
const isArray = Array.isArray;

function InquiryProjectIfbDetail(props) {
  const Config = {
    purchase: {
      title: '项目招标详情',
      apiPath: '/projectBidding/Order/detail',
      publishApiPath: '/projectBidding/Order/publish',
      publishScoreApiPath: '/projectEvaluateModule/publishScore',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Project_Bidding_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'pbXkNo',
      wfmCode: '1027'
    },
    sale: {
      title: '项目招标详情',
      apiPath: '/customerProjectBiddingOrder/detail',
      customerNameKey: 'companyName',
      companyCodeKey: 'customerCode',
      vendorNameKey: 'innerCustomerName',
      arrEnumField: [
        {
          mainKey: 'B02_Project_Bidding_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'pbXkNo'
    }
  };

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    decimalPlace,
    fileList,
    moreSign1,
    handleMore,
    setShowLoading,
    setFileList,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const [currNavIndex, setCurrNavIndex] = useState(Number);
  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true,
    2: true
  });
  const [list, setList] = useState([]);
  const [vQuoOrders, setVquoteOrders] = useState({});
  const [editSorce, setEditSorce] = useState(false);

  //处理详情数据
  self.afterGetDetail = async function (data) {
    //采购方公司名
    data.companyName = self.companyInfo.companyName;

    //招标公司
    let relateCompanyList = data.relateCompanyList || [];
    if (Array.isArray(relateCompanyList) && relateCompanyList.length !== 0) {
      data.inqRelateCompListShow = relateCompanyList.map(
        item => item.relateCompName
      );
    }
    data.fileMd5s = data.fileMd5s || [];
    data.prodList?.forEach(item => {
      item.prodCode = item.productCode;
      item.prodName = item.productName;
      item.prodScale = item.productScale;
      item.initunitCode = item.unitCode;
      item.initunitName = item.unitName;
      //特征码
      if (isArray(item.compProdFeatureList)) {
        item.feature = item.compProdFeatureList
          .filter(items => items.specShow === 1)
          .map(items => items.featureName)
          .join();
      }
    });
    data.taxRateShow = !Util.isEmpty(data.taxRate)
      ? parseFloat(Big(data.taxRate).times(100).valueOf())
      : undefined; //按百分比转换

    if (!Util.isEmpty(data.classifyList)) {
      data.classifyList.forEach(item => {
        if (data.status === 3) {
          if (!Util.isEmpty(item.vendorScoreList)) {
            item.vendorScoreList.forEach(row => {
              row.itemScoreList = row.itemScoreList || [];
              if (row.itemScoreList.length === 0) {
                item.itemList.forEach(rows => {
                  row.itemScoreList.push({
                    itemNo: rows.itemNo,
                    grade: '',
                    score: '',
                    evaluateDesc: '',
                    evaluateRate: rows.evaluateRate
                  });
                });
              }
            });
          } else {
            item.vendorScoreList = [];
          }
        }
      });
    }

    //获取投标记录
    if (User.checkAuth('10071308')) {
      await getQuoteOrderList(data);
    }

    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  // function handleBoxState(idx) {
  //   boxState[idx] = !boxState[idx];
  //   setBoxState(boxState);
  //   forceUpdate();
  // }

  // 切换tab
  function handleNav(event, type) {
    setCurrNavIndex(Number(type));
    if (
      detail.status >= 3 &&
      !['8', '9', '13'].includes(detail.status) &&
      self.isPurchase &&
      detail.pbXkNo
    ) {
      if (Number(type) === 1 && self.isPurchase) {
        getCompareList();
      }
    }
  }

  //获取报价对比列表
  //viewType 视图类型 1：物料模式, 2:供应商模式  默认：物料模式
  function getCompareList() {
    let postbody = {
      companyCode: companyCode,
      pbXkNo: detail.pbXkNo,
      orderProperty: 'createTime',
      ascOrDesc: 'desc',
      viewType: 1,
      apiPath: '/projectBidding/Order/compareQuotesPrint'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        if (!response.data) {
          ModalService.showInfo('暂无报价记录', dispatch);
          return;
        }
        let data = [];
        if (!response.data.templateUniqueCode) {
          data = response.data.prodPageList?.list || [];
          data.forEach(item => {
            item.activeFlag = true;
            item.prodDetails.forEach(line => {
              //判断是否含税,价格是否含税 0:不限；1:含税价；2:未税价; 默认值:0"，不限时，税率为0则未税
              if (line.priceContainTaxFlag === 0) {
                if (line.taxRate > 0) {
                  line.priceContainTaxFlagShow = true;
                } else {
                  line.priceContainTaxFlagShow = false;
                }
              } else if (line.priceContainTaxFlag === 1) {
                line.priceContainTaxFlagShow = true;
              } else if (line.priceContainTaxFlag === 2) {
                line.priceContainTaxFlagShow = false;
              } else {
                line.priceContainTaxFlagShow = false;
              }
              line.taxRateShow = !Util.isEmpty(line.taxRate)
                ? parseFloat(Big(line.taxRate).times(100).valueOf())
                : undefined; //按百分比显示税率
            });
          });
          detail.quoteCompareList = data;
        } else {
          detail.quoteTemplateDetailList = response.data.templateDetails || [];
          detail.quoteCustomFieldList = response.data.templateCustomFields;
          detail.quoteTemplateDetailList?.sort((a, b) => a.sortNo - b.sortNo);

          detail.quoteTemplateDetailList?.forEach(item => {
            item.activeFlag = true;
            item.vendorDetails.forEach(line => {
              //判断是否含税,价格是否含税 0:不限；1:含税价；2:未税价; 默认值:0"，不限时，税率为0则未税
              if (line.priceContainTaxFlag === 0) {
                if (line.taxRate > 0) {
                  line.priceContainTaxFlagShow = true;
                } else {
                  line.priceContainTaxFlagShow = false;
                }
              } else if (line.priceContainTaxFlag === 1) {
                line.priceContainTaxFlagShow = true;
              } else if (line.priceContainTaxFlag === 2) {
                line.priceContainTaxFlagShow = false;
              } else {
                line.priceContainTaxFlagShow = false;
              }
              line.taxRateShow = !Util.isEmpty(line.taxRate)
                ? parseFloat(Big(line.taxRate).times(100).valueOf())
                : undefined; //按百分比显示税率
            });
          });
        }
        setDetail(detail);
        forceUpdate();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  function handleDrawer(item) {
    item.activeFlag = !item.activeFlag;
    forceUpdate();
  }

  // 发布招标
  function publish() {
    let postbody = getPostbody(config.publishApiPath);
    InquiryService.publishProjectIfb(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }
  //发布评标结果
  function publishScore() {
    let postbody = getPostbody(config.publishScoreApiPath);
    let userInfo = User.getUserInfo();
    postbody.evaluateCode = userInfo.id;
    postbody.evaluateName = userInfo.nickName;
    InquiryService.publishScore(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }
  // 发布招标结果
  function publishResult() {
    let postbody = getPostbody(config.publishResultApiPath);
    InquiryService.publishProjectIfb(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //获取投标记录
  async function getQuoteOrderList(data) {
    let postbody = {
      companyCode: companyCode,
      pbXkNo: self.id,
      apiPath: '/vendorProjectQuoteOrder/getQuoteOrderList'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let vQuoteOrders = response.data || [];
        data.vQuoteOrders = vQuoteOrders;
        if (data.status > 3) {
          if (!Util.isEmpty(data.vQuoteOrders)) {
            data.vQuoteOrders.forEach(item => {
              item.checked = item.status === 7 ? true : false;
            });
          }
        }
        setVquoteOrders(data.vQuoteOrders);
        setDetail(data);
      }
    });
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      pbXkNo: self.id,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  function updateEvaluateScore() {
    let classifyScoreList = [];
    let gradeFlag = false;
    let gradeBig = false;

    if (!Util.isEmpty(detail.classifyList)) {
      detail.classifyList.forEach(item => {
        item.vendorScoreList.forEach(row => {
          row.itemScoreList.forEach(rows => {
            if (rows.grade === '') {
              gradeFlag = true;
            }
            if (rows.grade > 100) {
              gradeBig = true;
            }
            rows.score = rows.grade * rows.evaluateRate * 0.01;
          });
          classifyScoreList.push(row);
        });
      });
    }

    if (gradeFlag) {
      ModalService.showError('本项评分不能为空', dispatch);
      return;
    }
    if (gradeBig) {
      ModalService.showError('本项评分不能大于100', dispatch);
      return;
    }

    let userInfo = User.getUserInfo();
    let postbody = {
      companyCode: companyCode,
      pbXkNo: self.id,
      evaluateCode: userInfo.id,
      evaluateName: userInfo.nickName,
      classifyScoreList: classifyScoreList,
      apiPath: '/projectEvaluateModule/evaluateScore'
    };
    setShowLoading(true);
    Http.post('/api/cloudCenter', postbody).then(response => {
      setShowLoading(false);
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
        editclassifyScore();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  // 输入验证
  function handleInputChange(event, key, items, vendorScore, classify) {
    let detailObj = Util.clone(detail);
    let val = event.target.value;
    if (key === 'grade') {
      val = Util.qtyChange(event.target.value);
    }
    if (!Util.isEmpty(detail.classifyList)) {
      detailObj.classifyList.forEach(item => {
        if (item.classifyName === classify.classifyName) {
          item.vendorScoreList.forEach(row => {
            if (row.innerVendorCode === vendorScore.innerVendorCode) {
              row.itemScoreList.forEach(rows => {
                if (items.itemNo === rows.itemNo) {
                  rows[key] = val;
                }
              });
            }
          });
        }
      });
    }
    setDetail(detailObj);
  }

  function editclassifyScore() {
    let val = !editSorce;
    setEditSorce(val);
  }

  //查看附件
  function showFileList(businessType, obj, i, type) {
    const { actions } = props;
    let businessKey = detail.pbXkNo,
      xkNo = obj.pbXkNo,
      lineNo = obj.lineNo || '0',
      cCode = obj[config.companyCodeKey];

    if (businessType === 53) {
      businessKey = obj.uniqueKey;
    } else if (businessType === 54) {
      cCode = obj.vendorCode;
      businessKey = obj.pbqXkNo;
      if (obj && type === 'classifyBid') {
        businessKey = self.id + '_' + obj.classifyNo;
      }
    } else {
      businessKey = detail.pbXkNo;
    }

    setShowLoading(true);
    CompanyService.getFileList(
      businessType,
      businessKey,
      xkNo,
      lineNo,
      cCode
    ).then(res => {
      setShowLoading(false);
      if (Array.isArray(res)) {
        let arr = res.map(item => {
          return { ...item };
        });
        setFileList(arr);
      }
    });
    actions.openDownloadModal();
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      {detail.status > 1 && (
        <Paper square={true} style={{ marginBottom: '5px' }}>
          <Tabs
            value={currNavIndex}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleNav}
          >
            <Tab label={'基础信息'} />
            {detail.status >= 3 &&
              self.isPurchase &&
              !['8', '9', '13'].includes(detail.status) && (
                <Tab label={'报价对比'} />
              )}
          </Tabs>
        </Paper>
      )}
      {currNavIndex === 0 && (
        <div className="m-details-container">
          <div className="m-details-item">
            <div className="details-item-title">
              <label>基础信息</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">招标项目编号</span>
                    <div className="field-value">{detail.projectBidCode}</div>
                  </li>
                  <li>
                    <span className="field-label">招标平台单号</span>
                    <div className="field-value">{detail.pbInnerNo}</div>
                  </li>
                  <li>
                    <span className="field-label">招标项目名称</span>
                    <div className="field-value">{detail.projectBidName}</div>
                  </li>
                  <li>
                    <span className="field-label">招标类别</span>
                    <div className="field-value">{detail.bidCategoryName}</div>
                  </li>
                  <li>
                    <span className="field-label">招标企业</span>
                    {self.isPurchase && (
                      <div className="field-value">
                        {!Util.isEmpty(detail.inqRelateCompListShow) &&
                          detail.inqRelateCompListShow.map(
                            (vQuoItem, index) => (
                              <span key={index} className="f-ml10">
                                {vQuoItem}
                              </span>
                            )
                          )}
                      </div>
                    )}
                    {!self.isPurchase && (
                      <div className="field-value">
                        {detail.innerCustomerName}
                      </div>
                    )}
                  </li>
                  <li>
                    <span className="field-label">评标模板</span>
                    <div className="field-value">{detail.pemTitle}</div>
                  </li>

                  <li>
                    <span className="field-label">状态</span>
                    <div className="field-value">
                      <span
                        className={
                          'u-sign ' +
                          CommonFns.getStatusClass(
                            'B02_Project_Bidding_Status',
                            detail.status
                          )
                        }
                      >
                        {detail.statusName}
                      </span>
                    </div>
                  </li>
                  {/* 审批流状态 仅开启后才显示 */}
                  {self.isPurchase && updateTs > 0 && workflow.isActive && (
                    <li>
                      <span className="field-label">审批环节</span>
                      <div className="field-value">
                        <WorkflowStatus
                          companyCode={companyCode}
                          id={self.id}
                          workflow={workflow}
                          detail={detail}
                        />
                      </div>
                    </li>
                  )}
                  {/* 审批流按钮 */}
                  {self.isPurchase && updateTs > 0 && workflow.isActive && (
                    <li>
                      <span className="field-label">审批操作</span>
                      <div className="field-value">
                        <WorkflowButtons
                          companyCode={companyCode}
                          id={self.id}
                          workflow={workflow}
                          detail={detail}
                          onChange={() => {
                            self.getDetail();
                          }}
                        />
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className="m-details-item">
            <div className="details-item-title">
              <label>招标类型</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">保证金截止时间</span>
                    <div className="field-value">
                      {formatDate(detail.preAuditEndDate, 'YYYY-MM-DD HH:mm')}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">投标保证金</span>
                    <div className="field-value">
                      {formatNumber(detail.bidDeposit, decimalPlace.AMOUNT)} 元
                    </div>
                  </li>
                  <li>
                    <span className="field-label">投标截止时间</span>
                    <div className="field-value">
                      {formatDate(detail.bidEndDate, 'YYYY-MM-DD HH:mm')}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">招标书附件</span>
                    <div className="field-value">
                      {!Util.isEmpty(detail.fileMd5s) && (
                        <span
                          className="attachment"
                          onClick={() => showFileList(52, detail)}
                        >
                          {detail.fileMd5s.length}个附件
                          <i className="icon-attachment"></i>
                        </span>
                      )}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">招标说明</span>
                    <div className="field-value">{detail.description}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/*报价项目 */}

          <div className="m-details-item">
            <div className="details-item-title">
              <label>报价项目</label>
              {/* <i className="icon-down" onClick={() => handleBoxState(1)}></i> */}
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">币别</span>
                    <div className="field-value">
                      {detail.quoteCurrencyName}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">税别</span>
                    <div className="field-value">{detail.taxName}</div>
                  </li>
                  <li>
                    <span className="field-label">是否含税</span>
                    <div className="field-value">
                      {detail.priceContainTaxFlag === 1
                        ? '含税价'
                        : detail.priceContainTaxFlag === 2
                          ? '未税价'
                          : '不限'}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">税率</span>
                    <div className="field-value">{detail.taxRateShow} %</div>
                  </li>
                </ul>
              </div>
            </div>
            {!Util.isEmpty(detail.prodList) && (
              <div className="details-item-content f-mt10">
                {detail.prodList.map((item, index) => (
                  <div className="content-line line-list-item" key={index}>
                    <div className="line-list-item-title">
                      <span>序号 {index + 1}</span>
                    </div>
                    <ul className="field-list">
                      <li>
                        <span className="field-label">编码</span>
                        <div className="field-value">{item.prodCode}</div>
                      </li>
                      <li>
                        <span className="field-label">名称</span>
                        <div className="field-value">{item.prodName}</div>
                      </li>
                      <li>
                        <span className="field-label">规格（特征值）</span>
                        <div className="field-value">
                          {item.prodScale} {item.feature}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">数量</span>
                        <div className="field-value">
                          {formatNumber(item.purchaseQty, decimalPlace.QTY)}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">单位</span>
                        <div className="field-value">
                          {item.initunitName || item.unitName}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">期望价格</span>
                        <div className="field-value">
                          {formatNumber(item.expectedPrice, decimalPlace.PRICE)}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">上限价格</span>
                        <div className="field-value">
                          {formatNumber(
                            item.upperLimitPrice,
                            decimalPlace.PRICE
                          )}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">图纸/文档</span>
                        <div className="field-value">
                          {!Util.isEmpty(item.fileMd5s) && (
                            <span
                              className="attachment"
                              onClick={() => showFileList(53, item, index)}
                            >
                              {item.fileMd5s.length}个附件
                              <i className="icon-attachment"></i>
                            </span>
                          )}
                        </div>
                      </li>
                    </ul>
                  </div>
                ))}
              </div>
            )}
          </div>

          {self.isPurchase && (
            // 邀请供应商
            <div className="m-details-item">
              <div className="details-item-title">
                <label>邀请供应商</label>
                {/* <i className="icon-down" onClick={() => handleBoxState(2)}></i> */}
              </div>
              <div className="details-item-content">
                <div className="content-line">
                  <ul className="field-list">
                    <li>
                      <span className="field-label">类型</span>
                      <div className="field-value">
                        {detail.quoteRangeType === 1
                          ? '仅限指定供应商'
                          : '公开招标'}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              {!Util.isEmpty(detail.vendorList) && (
                <div className="details-item-content f-mt10">
                  {detail.vendorList.map((item, index) => (
                    <div className="content-line line-list-item" key={index}>
                      <div className="line-list-item-title">
                        <span>序号{index + 1}</span>
                      </div>
                      <ul className="field-list">
                        <li>
                          <span className="field-label">供应商编码</span>
                          <div className="field-value">
                            {item.innerVendorCode}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">供应商名称</span>
                          <div className="field-value">
                            {item.innerVendorName}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">供应商类型</span>
                          <div className="field-value">
                            {item.newFlag === 0
                              ? '正式供应商'
                              : item.newFlag === 2
                                ? '潜在供应商'
                                : '平台'}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">平台状态</span>
                          <div className="field-value">
                            {item.handshakeFlag === 2 ? '已加入' : '未加入'}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">接收人</span>
                          <div className="field-value">
                            {item.contactPerson}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">手机号码</span>
                          <div className="field-value">
                            {item.mobile ? item.mobileArea : ''} {item.mobile}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">邮箱</span>
                          <div className="field-value">{item.mailbox}</div>
                        </li>
                      </ul>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          {/* 投标记录 */}
          {self.isPurchase &&
            detail.status === 3 &&
            User.checkAuth('10071308') && (
              <div className="order-detail-block">
                <div className="order-detail-title">
                  <label>投标记录</label>
                </div>
                {!Util.isEmpty(detail.vQuoteOrders) && (
                  <div className="order-detail-list">
                    <ul>
                      {detail.vQuoteOrders.map((vQuoItem, index) => (
                        <li className="order-detail-item" key={index}>
                          <span className="lineNo">项次 {index + 1}</span>
                          <ul className="clearfix">
                            <li>
                              供应商编码：
                              {vQuoItem.innerVendorCode}
                            </li>
                            <li>
                              供应商名称：
                              {vQuoItem.innerVendorName}
                            </li>
                            <li>
                              投标文件：
                              {!Util.isEmpty(vQuoItem.bidFileMd5s) && (
                                <span
                                  className="attachment"
                                  onClick={() =>
                                    showFileList(54, vQuoItem, index)
                                  }
                                >
                                  {vQuoItem.bidFileMd5s.length}个附件
                                  <i className="icon-attachment"></i>
                                </span>
                              )}
                            </li>
                            <li>
                              投标价格：
                              {vQuoItem.totalPrice}
                            </li>
                            <li>价格排名: {vQuoItem.priceRank}</li>
                            <li>
                              价格得分:
                              {vQuoItem.mainScore}
                            </li>
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {self.isPurchase && !Util.isEmpty(detail.classifyList) && (
                  <div className="order-detail-list">
                    <ul>
                      {detail.classifyList.map((item, index) => (
                        <li className="order-detail-item" key={index}>
                          {item.itemList.map((row, itemIndex) => (
                            <ul className="clearfix" key={itemIndex}>
                              <li>评分项目: {row.itemName}</li>
                              <li>评分说明: {row.evaluateDesc}</li>
                              <li>该项占比: {row.evaluateRate}</li>
                            </ul>
                          ))}

                          {item.vendorScoreList.map((row, itemIndex) => (
                            <ul className="clearfix" key={itemIndex}>
                              <li className="single">
                                供应商编码: {row.innerVendorCode}
                              </li>
                              <li className="single">
                                供应商名称: {row.innerVendorName}
                              </li>
                              <li className="single">
                                投标说明: {row.bidDesc}
                              </li>
                              <li>该类得分: {row.grade}</li>
                              <li>
                                该类附件:
                                {!Util.isEmpty(row.classifyBidFileMd5s) && (
                                  <span
                                    className="attachment"
                                    onClick={() => showFileList(54, row, index)}
                                  >
                                    {row.bidFileMd5s.length}个附件
                                    <i className="icon-attachment"></i>
                                  </span>
                                )}
                              </li>
                              <li className="single">
                                {!Util.isEmpty(row.itemScoreList) &&
                                  row.itemScoreList.map((rows, j) => (
                                    <ul className="clearfix" key={j}>
                                      <li>评分项: {rows.itemNo}</li>
                                      <li>
                                        本项得分:{' '}
                                        {formatNumber(
                                          rows.grade * rows.evaluateRate * 0.01,
                                          2
                                        )}
                                      </li>
                                      <li className="single">
                                        本项评分:
                                        {editSorce && (
                                          <input
                                            type="text"
                                            className="fieldInputClass"
                                            value={rows.grade}
                                            onChange={e =>
                                              handleInputChange(
                                                e,
                                                'grade',
                                                rows,
                                                row,
                                                item
                                              )
                                            }
                                          />
                                        )}
                                        {!editSorce && rows.grade}
                                      </li>
                                      <li className="single">
                                        评分说明:
                                        {editSorce && (
                                          <input
                                            type="text"
                                            className="fieldInputClass"
                                            value={rows.evaluateDesc}
                                            onChange={e =>
                                              handleInputChange(
                                                e,
                                                'evaluateDesc',
                                                rows,
                                                row,
                                                item
                                              )
                                            }
                                          />
                                        )}
                                        {!editSorce && rows.evaluateDesc}
                                      </li>
                                    </ul>
                                  ))}
                              </li>
                            </ul>
                          ))}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          {/* 评标汇总 */}
          {self.isPurchase && [4, 5].includes(detail.status) && (
            <div className="order-detail-block">
              <div className="order-detail-title">
                <label>评标汇总</label>
              </div>
              {!Util.isEmpty(detail.vQuoteOrders) && (
                <div className="order-detail-list">
                  <ul>
                    {detail.vQuoteOrders.map((vQuoItem, index) => (
                      <li className="order-detail-item" key={index}>
                        <span className="lineNo">项次 {index + 1}</span>
                        <ul className="clearfix">
                          <li>
                            供应商编码：
                            {vQuoItem.innerVendorCode}
                          </li>
                          <li>
                            供应商名称：
                            {vQuoItem.innerVendorName}
                          </li>
                          <li>
                            投标文件：
                            {!Util.isEmpty(vQuoItem.bidFileMd5s) && (
                              <span
                                className="attachment"
                                onClick={() =>
                                  showFileList(54, vQuoItem, index)
                                }
                              >
                                {vQuoItem.bidFileMd5s.length}个附件
                                <i className="icon-attachment"></i>
                              </span>
                            )}
                          </li>
                          <li>
                            价格得分:
                            {vQuoItem.mainScore}
                          </li>
                          <li>
                            报价总价：
                            {vQuoItem.totalPrice}
                          </li>
                          <li>价格排名: {vQuoItem.priceRank}</li>
                          {!Util.isEmpty(detail.classifyList) &&
                            detail.classifyList.map((classItem, i) => (
                              <li key={i}>
                                {classItem.classifyName}:
                                {!Util.isEmpty(vQuoItem.classifyScoreList) &&
                                  vQuoItem.classifyScoreList.map(
                                    (scoreItem, j) => (
                                      <span key={j}>
                                        {scoreItem.classifyNo ===
                                          classItem.classifyNo && (
                                          <span>
                                            {scoreItem.evaluateName}{' '}
                                            {scoreItem.score || '--'}
                                          </span>
                                        )}
                                      </span>
                                    )
                                  )}
                              </li>
                            ))}
                          <li>
                            总得分：
                            {vQuoItem.totalScore}
                          </li>
                          <li>
                            中标方：
                            {vQuoItem.checked ? '是' : '否'}
                          </li>
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}

          {/* 备注说明 */}
          {self.isPurchase && [4, 5].includes(detail.status) && (
            <div className="order-detail-block">
              <div className="order-detail-title">
                <label>备注说明</label>
              </div>
              <ul>
                <li>
                  <label className="order-detail-label">
                    {detail.evaluateDesc}
                  </label>
                </li>
              </ul>
            </div>
          )}
        </div>
      )}
      {currNavIndex === 1 && (
        <div>
          {' '}
          <IfbPriceCompare
            templateUniqueCode={detail.templateUniqueCode}
            prodList={detail.quoteCompareList}
            quoteTemplateDetailList={detail.quoteTemplateDetailList}
            quoteCustomFieldList={detail.quoteCustomFieldList}
            companyCode={companyCode}
            decimalPlace={decimalPlace}
            handleDrawer={data => handleDrawer(data)}
          ></IfbPriceCompare>
        </div>
      )}
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10071302') &&
            [0].includes(detail.status) &&
            workflow.data &&
            workflow.data['project_bidding_publish_1'].complete && (
              <Button
                type="default"
                onClick={() => {
                  publish();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布招标
              </Button>
            )}

          {detail.status === 3 &&
            !editSorce &&
            detail.evaluateFinishFlag !== 1 &&
            detail.classifyList?.length > 0 && (
              <Button
                type="default"
                onClick={() => {
                  editclassifyScore();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                编辑
              </Button>
            )}
          {detail.status === 3 &&
            !editSorce &&
            detail.evaluateFinishFlag !== 1 &&
            detail.classifyList?.length > 0 && (
              <Button
                type="default"
                onClick={() => {
                  publishScore();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布评标结果
              </Button>
            )}
          {detail.status === 3 && editSorce && (
            <Button
              type="default"
              onClick={() => {
                updateEvaluateScore();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              保存
            </Button>
          )}
        </div>
      )}
      {/* {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10071306') &&
            [4].includes(detail.status) &&
            workflow.data &&
            workflow.data['project_bidding_publish_2'].complete && (
              <Button
                type="default"
                onClick={() => {
                  publishResult();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布招标结果
              </Button>
            )}
        </div>
      )} */}
      <Modal></Modal>
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
    </div>
  );
}

InquiryProjectIfbDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InquiryProjectIfbDetail);
